import {
  Box,
  Button,
  Card,
  HStack,
  Image,
  Progress,
  Stack,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { GetPokemon } from "../../hooks/get-pokemon";
import { Lang } from "../../hooks/lang";

/**
 * メモ
 * なぜか2回レンダリングが走るようです
 * console.logで確認可能
 */
export const Detail = () => {
  const { t } = Lang();
  const params = useParams();
  const id = Number(params.id);
  const { isLoading, pokemon } = GetPokemon(id);
  const types = pokemon?.types
    .map((type) => t("type_name." + type.type.name))
    .join(", ");
  const height = pokemon?.height ?? 0;
  const weight = pokemon?.weight ?? 0;

  return (
    <Box justifyContent={"center"} display={"flex"} pt={"100px"}>
      {isLoading ? (
        <Spinner />
      ) : (
        <Card.Root overflow="hidden" variant="outline">
          <Card.Body>
            <HStack alignItems="stretch">
              <VStack>
                <Stack>
                  <Image
                    boxSize="160px"
                    src={pokemon?.sprites?.front_default}
                    alt="Image"
                  />
                </Stack>
                <Stack>
                  <Text fontWeight="bold">No : {pokemon?.id}</Text>
                  <Text fontWeight="bold">
                    {t("name")} : {t("pokemon_name." + pokemon?.name)}
                  </Text>
                  <Text fontWeight="bold">
                    {t("type")} : {types}
                  </Text>
                  <Text fontWeight="bold">
                    {t("height")} : {height / 10} m
                  </Text>
                  <Text fontWeight="bold">
                    {t("weight")} : {weight / 10} kg
                  </Text>
                </Stack>
              </VStack>
              <Stack
                borderRadius={"10px"}
                borderWidth={"2px"}
                p={"0.5rem"}
                justifyContent={"center"}
              >
                {pokemon?.stats.map((stat) => {
                  return (
                    <Box>
                      <Text fontWeight="bold">
                        {t("stats." + stat.stat.name)}
                      </Text>
                      <Box width={"200px"}>
                        <Progress.Root
                          colorScheme={"green"}
                          value={stat.base_stat}
                          max={100}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </Stack>
            </HStack>
          </Card.Body>
          <Card.Footer>
            <Button asChild>
              <a href="/pokemons">Back</a>
            </Button>
          </Card.Footer>
        </Card.Root>
      )}
    </Box>
  );
};
